import { configureStore } from "@reduxjs/toolkit";
import hotelReducer from "../features/bookings/hotelSlice";
import flightReducer from "../features/bookings/flightSlice";
import transferReducer from "../features/bookings/transferSlice";
import carrentReducer from "../features/bookings/carrentSlice";
import visaReducer from "../features/bookings/visaSlice";
import insuranceReducer from "../features/bookings/insuranceSlice";
import sightReducer from "../features/bookings/sightSlice";
import allBookingReducer from "../features/allBookingSlice";
import contactReducer from "../features/ContactSlice";
import cmsReducer from "../features/cmsSlice";
//
import userReducer from "../features/userSlice";
//
import crmAuthReducer from "../features/crm/crmAuthSlice";
import crmAgentReducer from "../features/crm/crmAgentSlice";
import crmAdminReducer from "../features/crm/crmAdminSlice";
import crmCatalogReducer from "../features/crm/crmCatalogSlice";
import crmBookingsReducer from "../features/crm/crmBookingsSlice";
import crmInquiryReducer from "../features/crm/crmInquirySlice";
import crmPolicyReducer from "../features/crm/crmPolicySlice";
import crmStaffReducer from "../features/crm/crmStaffSlice";
import crmNotificationReducer from "../features/crm/crmNotificationSlice";
import crmReportReducer from "../features/crm/crmReportSlice";

export default configureStore({
    reducer: {
        user: userReducer,
        crmAuth: crmAuthReducer,
        crmAgent: crmAgentReducer,
        crmAdmin: crmAdminReducer,
        crmCatalog: crmCatalogReducer,
        crmBookings: crmBookingsReducer,
        crmInquiry: crmInquiryReducer,
        crmPolicy: crmPolicyReducer,
        crmStaff: crmStaffReducer,
        crmNotification: crmNotificationReducer,
        crmReport: crmReportReducer,
        hotel: hotelReducer,
        flight: flightReducer,
        transfer: transferReducer,
        carrent: carrentReducer,
        visa: visaReducer,
        insurance: insuranceReducer,
        sight: sightReducer,
        allBookings: allBookingReducer,
        contact: contactReducer,
        cms: cmsReducer,
    },
});
